/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Reports_Cases_By_ClientInputs */

const en_nav_reports_cases_by_client = /** @type {(inputs: Nav_Reports_Cases_By_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cases by client`)
};

const pt_br2_nav_reports_cases_by_client = /** @type {(inputs: Nav_Reports_Cases_By_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Casos por cliente`)
};

/**
* | output |
* | --- |
* | "Cases by client" |
*
* @param {Nav_Reports_Cases_By_ClientInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const nav_reports_cases_by_client = /** @type {((inputs?: Nav_Reports_Cases_By_ClientInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Reports_Cases_By_ClientInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_reports_cases_by_client(inputs)
	return pt_br2_nav_reports_cases_by_client(inputs)
});